import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {PaymentProfile} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: PaymentProfile,
        handleSubmit: (values: PaymentProfile) => void
    }) => {

    const title = record?.id ? `Edit Payment Profile` : `Add Payment Profile`;

    const handleFormSubmit = async (values: PaymentProfile) => {
        const payload = {
            ...values,
            customerId: values.customerId || record.customerId
        };
        await handleSubmit(payload);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};